import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserKycApplicationDetailsDto } from '../../../_core/_model/compliance';
import { ComplianceApiService } from '../../../_core/_services/_compliance/compliance-api.service';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-my-kyc-application-details',
  standalone: false,
  templateUrl: './my-kyc-application-details.html',
  styleUrl: './my-kyc-application-details.css',
})
export class MyKycApplicationDetails implements OnInit {
  loading = false;
  error: string | null = null;
  applicationId = '';
  application: UserKycApplicationDetailsDto | null = null;

  deleteBusy = false;

  constructor(
    private notifyService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private api: ComplianceApiService
  ) {}

  ngOnInit(): void {
    this.applicationId = this.route.snapshot.paramMap.get('applicationId') || '';
    if (!this.applicationId) {
      this.error = 'Application not found.';
      this.notifyService.showError(this.error!, 'Error');
      return;
    }

    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;

    this.api.getApplicationById(this.applicationId).subscribe({
      next: (res) => {
        this.application = res.data || null;
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to load application.';
        this.notifyService.showError(this.error!, 'Error');
        this.loading = false;
      }
    });
  }

  continueApplication(): void {
    if (!this.application) return;
    this.router.navigate(['/compliance/wizard', this.application.applicationId]);
  }

  resubmit(): void {
    if (!this.application) return;
    this.router.navigate(['/compliance/resubmit', this.application.applicationId]);
  }

  canContinue(): boolean {
    const status = this.application?.status;
    return status === 'Draft' || status === 'PendingSubmission' || status === 'Rejected';
  }

  canResubmit(): boolean {
    return this.application?.status === 'Rejected';
  }

  getStatusClass(status?: string): string {
    switch (status) {
      case 'Approved': return 'text-bg-success';
      case 'Rejected': return 'text-bg-danger';
      case 'Submitted':
      case 'UnderReview': return 'text-bg-warning';
      default: return 'text-bg-secondary';
    }
  }

  canDelete(): boolean {
    return this.application?.status === 'Draft';
  }

  deleteApplication(): void {
    if (!this.application?.applicationId) return;

    const confirmed = window.confirm('Delete this draft application? This cannot be undone.');
    if (!confirmed) return;

    this.deleteBusy = true;
    this.error = null;

    this.api.deleteApplication(this.application.applicationId).subscribe({
      next: () => {
        this.deleteBusy = false;
        this.router.navigate(['/compliance/applications']);
      },
      error: (err) => {
        this.deleteBusy = false;
        this.error = err?.error?.message || 'Failed to delete application.';
      }
    });
  }

  trackByField = (_: number, item: { fieldKey: string }) => item.fieldKey;
  trackByDoc = (_: number, item: { id: string }) => item.id;
}